import type { CellProps } from 'react-table';
import type { FilesTableItem } from './interfaces';
import { Tags } from './Tags';

export default function FileTags({ row: { original: data } }: CellProps<FilesTableItem>) {
  return <Tags tags={data.tags} maxTags={1} />;
}

export { FileTags };